import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Pais {
  static getPaises () {
    const axios = getAxiosInstance()
    const promise = axios.get(`pais_listado?r=` +
    `{"orden":["nombre"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getPaisByNombreCorto (nombreCorto) {
    const axios = getAxiosInstance()
    const promise = axios.get(`pais?r=` +
    `{"clave": {"nombre_corto" : "${nombreCorto.trim()}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0])
  }
}

export default Pais
